import { render, staticRenderFns } from "./DomainListItemActions.vue?vue&type=template&id=48af8a5d&scoped=true"
import script from "./DomainListItemActions.vue?vue&type=script&lang=js"
export * from "./DomainListItemActions.vue?vue&type=script&lang=js"
import style0 from "./DomainListItemActions.vue?vue&type=style&index=0&id=48af8a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af8a5d",
  null
  
)

export default component.exports